import Wpp from 'components/wpp/Wpp'
import About from 'components/about/About'
import Card from 'components/card/Card'
import Parallax from 'components/parallax/parallax'
import Swiper from 'components/slider/Swiper'
import type { Route } from './+types'

export function meta({}: Route.MetaArgs) {
  return [
    { title: "Meu Caribe" },
    { name: "description", content: "Piscinas Naturais, Passeio de Buggy e Jet Ski em Maragogi" },
  ];
}

export default function index() {
  return (
    <>
      <Swiper></Swiper>
      <div className="flex flex-wrap justify-center my-10">
        <Card title="Piscinas Naturais" image="/01.webp" href="/piscinas-naturais">
            Tenha uma experiência inesquecível nas famosas Piscinas Naturais de Maragogi
        </Card>
        <Card title="Jet Ski" image="/20.webp" href="/jetski">
          Faça um passeio inesquecível pelas águas cristalinas de Maragogi
        </Card>
        <Card title="Banana e Disco Boat" image="/16.webp" href="/boat">
            Muita aventura e diversão no Caribe Brasileiro
        </Card>
      </div>
      <Parallax></Parallax>
      <About></About>
      <Wpp></Wpp>
    </>
  )
}
